import React, { useEffect, useState } from "react";
import "../ExternalCard/ExternalShareurl.scss";
import { getDeviceIcon } from "../../utils/deviceIcons";
import DeviceActionIcon from "../../assets/images/icCar-action.png";
import Shareicons from "../../assets/images/share-icon.svg";
import { useContextValue } from '../../context/LoaderContext';
import useApi from "../../hook/useAPI";
import { DEVICE } from "../../utils/const";
import ChargedBattery from "../../assets/images/ChargedBattery.svg";
import DeviceStatusBadge, { DeviceConnectionText } from "../DeviceStatus/DeviceStatusBadge";
import { findDeviceInList, mergeDeviceRagFields } from "../../utils/deviceRagDisplay";

function ExternalShareurl({ deviceDetails, setTripDetail, devicesList, setCenter, setSearchTerm, tripDetail }) {

  const { getData } = useApi();
  const { setDevice } = useContextValue();
  const [location, setLocation] = useState();
  const [currentDeviceDetails, setCurrentDeviceDetails] = useState({});
  const onClose = () => {
    setSearchTerm(" ");
    setDevice('');
    localStorage.removeItem("current_select_device_id")
    if (setCenter) {
      setCenter(location?.[0]?.latestRecord ? { "lat": Number(location?.[0]?.latestRecord?.latitude), "lng": Number(location?.[0]?.latestRecord?.longitude) } : { "lat": 33.5779, "lng": -101.8552 })
    }
    setTripDetail && setTripDetail(null);
  }

  useEffect(() => {
    if (!deviceDetails?._id) {
      setCurrentDeviceDetails({});
      return;
    }
    const locationRow = findDeviceInList(deviceDetails, devicesList);
    setCurrentDeviceDetails((prev) =>
      mergeDeviceRagFields(deviceDetails, locationRow, prev?._id ? prev : null),
    );
  }, [deviceDetails, devicesList]);

  useEffect(() => {
    let cancelled = false;

    const loadDeviceRecord = async () => {
      if (!deviceDetails?._id) {
        return;
      }

      try {
        const response = await getData(DEVICE.GET_CURRENT_DEVICE_STATUS, deviceDetails._id, false);
        const freshDevice = Array.isArray(response?.data) ? response.data[0] : null;
        if (cancelled || !freshDevice) {
          return;
        }
        const locationRow = findDeviceInList(deviceDetails, devicesList);
        setCurrentDeviceDetails((prev) =>
          mergeDeviceRagFields(freshDevice, locationRow, deviceDetails, prev?._id ? prev : null),
        );
      } catch (err) {
        if (!cancelled) {
          const locationRow = findDeviceInList(deviceDetails, devicesList);
          setCurrentDeviceDetails((prev) =>
            mergeDeviceRagFields(deviceDetails, locationRow, prev?._id ? prev : null),
          );
        }
      }
    };

    loadDeviceRecord();
    return () => {
      cancelled = true;
    };
  }, [deviceDetails?._id, getData]);

  const getDevice = async () => {
    try {
      const response = await getData(`${DEVICE?.GET_DEVICE_LOCATIONS_v2}/?page=${1}&limit=${100}`);
      if (response.status == 200 && response?.data.length > 0) {
        const deviceStoredData = JSON.parse(localStorage.getItem('deviceData')) || [];
        const deviceLocation = response.data?.filter((data) => data?.deviceId === deviceStoredData?.[0]?._id);
        setLocation(deviceLocation)
      } else {
        console.log('Failed to fetch device details.');
      }
    } catch (err) {
      console.error("Error fetching device details:", err);
    }
  }
  useEffect(() => {

    getDevice();
  }, [])


  return (
    <>
      <div className="card external-share-card h-auto">
        <div className="card-body">
          <div className="home-device-box">
            <div className="top_bar">
              {/* <div className="card_title">Devices</div> */}
              <div className="battery-top">
                <img src={ChargedBattery} alt="ChargedBattery" />
                <span>Battery {currentDeviceDetails?.batteryLevel != null ? `${currentDeviceDetails.batteryLevel}%` : '—'}</span>
              </div>
              <div className="top-bar-right">
                <div className="form_field_wrapper">
                  {/* <button className="url-button ex-btn">
                        {" "}
                        <img src={Shareicons} alt="" /> External Share Url
                      </button> */}
                </div>
                <div className="form_field_wrapper">
                  <button
                    className="url-button closebutton f-25"
                    onClick={() => onClose()}
                  >
                    <i className="bi bi-x-circle"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="bottom_bar">

              <div className="device-list-box">
                <div className="device-list">
                  <div className="device-left">
                    <div className="device-icon">
                      <img
                        src={getDeviceIcon(currentDeviceDetails.deviceCategory)}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="device-name">
                      <h5>{currentDeviceDetails.name}</h5>
                      <DeviceConnectionText device={currentDeviceDetails} />

                    </div>
                  </div>
                  <DeviceStatusBadge device={currentDeviceDetails} />
                  <div className="device-action">
                    {/* <button id="dropdownMoreMenu1" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img
                              src={DeviceActionIcon}
                              className="img-fluid"
                              alt="three-dot-image"
                            />
                          </button>
                          <ul className="profile dropdown-menu" aria-labelledby="dropdownMoreMenu1">
                            <li><a className="dropdown-item"><span className="item_text">Action 1</span></a></li>
                            <li><a className="dropdown-item"><span className="item_text">Action 2</span></a></li>
                            <li><a className="dropdown-item"><span className="item_text">Action 3</span></a></li>
                          </ul> */}
                  </div>
                </div>
                <div className="device-nuber-block">
                  <div className="device-number-items">
                    <div className="device-number-title">IMEI</div>
                    <div className="device-number-digit">
                      {currentDeviceDetails?.imeiNumber}
                    </div>
                  </div>
                  <div className="device-number-items">
                    <div className="device-number-title">SIM</div>
                    <div className="device-number-digit">
                      {currentDeviceDetails?.simCardNumber}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default ExternalShareurl